import { useCallback, useMemo } from 'react';
import { Obstacle } from '@thive/fddm-types';

import { SelectInput } from '@common/components/inputs';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { useReadSelectedObstacles } from '@/modules/floorplanDesign/hooks/';
import { IFddmService } from '@/modules/canvas/services/Floorplan/IFddmService';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';

const WALL_APPEARANCE_OPTIONS: { label: string; value: Obstacle['appearance'] }[] = [
  {
    label: 'Pillar',
    value: 'PILLAR',
  },
  {
    label: 'Box',
    value: 'BOX',
  },
  {
    label: 'Warning zone',
    value: 'WARNING_ZONE',
  },
];

function Appearance() {
  const obstacles = useReadSelectedObstacles();
  const fddmSvc: IFddmService = useMemo(
    () => FddmServiceFactory.getInstance().createFddmService(),
    [],
  );

  const onChange = useCallback(
    (newValue: Obstacle['appearance']) => {
      const obstacle = obstacles[0];
      fddmSvc.setPreference('obstacle.appearance', newValue);
      fddmSvc.updateObstacle({
        ...obstacle,
        appearance: newValue,
        wallMaterial: newValue === 'WALL' ? obstacle.wallMaterial ?? 'CONCRETE' : undefined,
      });
    },
    [obstacles, fddmSvc],
  );

  if (obstacles.length !== 1) return null;

  const { appearance } = obstacles[0];
  if (!appearance) return null;

  return (
    <PropertiesLabel i18nkey='interface:properties.obstacle.type'>
      <SelectInput options={WALL_APPEARANCE_OPTIONS} onChange={onChange} value={appearance} />
    </PropertiesLabel>
  );
}

export default Appearance;
